import axios, { CancelToken } from 'axios'
import jsonWebToken from 'Services/jsonWebToken'
import { apiUrl } from 'Services/accessUrl'
import { removeDiacritics } from 'Services/extraString'
import { ApiResult } from 'Types';

const endpoint = `${apiUrl.noVersion}/Upload`

/**
 * Upload any file-like image to the server.
 * The image will be saved in a lossy formated in a neutral exif position.
 * @param {File} file - A Blob object. Can also be a File.
 * @param {(event: ProgressEvent) => void} progress
 * @param {import('axios').CancelToken} token
 */
export const uploadImage = (file, progress, token = null) => {
  const url = `${endpoint}/ImageFromFormDatamage`
  const data = new FormData()
  const config = {}

  data.append('file', file, removeDiacritics(file.name))

  config.headers = {}
  config.headers.Authorization = jsonWebToken.header.Authorization
  config.headers['Content-Type'] = 'multipart/form-data'

  config.onUploadProgress = progress

  if (token !== null) {
    config.cancelToken = token
  }

  return axios.post(url, data, config)
}

/** Upload any file-like image to the server */
export const uploadFile = (
  file: File,
  onUploadProgress: (event: ProgressEvent) => void,
  token: CancelToken = null
): ApiResult<any> => {
  const url = `${endpoint}/file`

  const headers = {
    'Authorization': jsonWebToken.header.Authorization,
    'Content-Type': 'multipart/form-data'
  }

  const config = {
    headers,
    onUploadProgress,
  }

  if (token !== null)
    config['cancelToken'] = token

  const data = new FormData()
  data.append('file', file, removeDiacritics(file.name))

  return axios.post(url, data, config)
}

export default {
  uploadImage,
  uploadFile,
}